import { $Formutil, connect, EasyField } from 'react-bootstrap-formutil';
import FormGroup, { FormGroupProps } from 'components/FormGroup';
import CountrySelect, { BaseCountrySelectProps } from 'components/forms/CountrySelect';
import { printf } from 'utils/i18n';

export interface CountryFormutil {
    country: string;
    born_country: string;
}

export interface CountryProps extends FormGroupProps {
    disabled?: boolean;
    isSSN: boolean;
    $formutil: $Formutil<CountryFormutil>;
    countrySelectProps?: Omit<BaseCountrySelectProps, 'isSSN'>;
}

const Country: React.FC<CountryProps> = ({
    $formutil,
    disabled,
    isSSN,
    countrySelectProps,
    $onFieldChange,
    ...restProps
}) => {
    const { limitCountryList, disabled: countrySelectDisabled, ...restCountrySelectProps } = countrySelectProps || {};
    // 非SSN开户的国籍没有指定的默认值
    const $defaultValue = limitCountryList?.[0] || (isSSN ? 'USA' : '');

    return (
        <>
            <FormGroup
                $onFieldChange={(newVal, oldVal, $formutil) => {
                    $onFieldChange?.(newVal, oldVal, $formutil);

                    $formutil.$setValues({
                        born_country: newVal
                    });
                }}
                $defaultValue={$defaultValue}
                label={__('Citizenship')}
                name="country"
                checker={value => !!value || printf(__('Please select your %s'), __('citizenship'))}
                {...restProps}>
                <CountrySelect
                    isSSN={isSSN}
                    limitCountryList={limitCountryList}
                    disabled={countrySelectDisabled || disabled}
                    fieldName="country"
                    {...restCountrySelectProps}
                />
            </FormGroup>
            <EasyField name="born_country" type="hidden" $defaultValue={$defaultValue} />
        </>
    );
};

export default connect(Country);
